import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

export const RenameConversationForm = ({
  initialTitle = '',
  onRename,
  onCancel,
}) => {
  const [title, setTitle] = useState(initialTitle);

  useEffect(() => {
    setTitle(initialTitle);
  }, [initialTitle]);

  const handleSubmit = () => {
    if (title.trim()) {
      onRename(title.trim());
    }
  };

  return (
    <Box className="conversation-rename-container">
      <Stack className="rename-form-stack">
        <Box className="rename-title-row">
          <Typography variant="subtitle1">Rename</Typography>
        </Box>

        <TextField
          autoFocus
          margin="none"
          placeholder="Enter conversation title"
          type="text"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSubmit();
            }
          }}
          variant="outlined"
          size="small"
        />

        <Box className="rename-buttons-row">
          <Button
            onClick={onCancel}
            variant="contained"
            size="small"
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={!title.trim()}
            variant="contained"
            size="small"
            className="save-button"
          >
            Rename
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

RenameConversationForm.propTypes = {
  initialTitle: PropTypes.string,
  onRename: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
